import { useCallback } from "react";

import dayjs from "@/lib/dayjs";
import { getTodaysDate } from "@/lib/dayjs/get-todays-date";

import { Button } from "@/components/ui/button/button";

import { getStockDailyItemID } from "../daily-item";

import type { ComponentProps } from "react";

type Props = {
	/**
	 * 選択されている日付
	 * 現状特定の年月しか選択できないので、年月は１つしか存在しない
	 */
	selectedDate: string;
};

export const StockManagementScrollToTodaysStockItemMobile = ({ selectedDate }: Props) => {
	const todaysDate = getTodaysDate();
	const id = getStockDailyItemID(todaysDate);

	// selectedDate と todaysDate の年月が一致して居るかどうか
	const isSameYearMonth = dayjs(todaysDate).isSame(selectedDate, "month");
	// クリックできるかどうか
	const isClickable = isSameYearMonth;

	const variant: ComponentProps<typeof Button>["variant"] = isClickable ? "outline" : "disabled";

	const handleClick = useCallback(() => {
		const element = document.getElementById(id);
		if (element) {
			element.scrollIntoView({ block: "center", behavior: "smooth" });
		}
	}, [id]);

	return (
		<Button className="laptop:hidden" variant={variant} disabled={!isClickable} type="button" onClick={handleClick}>
			今日の日付に移動する
		</Button>
	);
};

StockManagementScrollToTodaysStockItemMobile.displayName = "StockManagementScrollToTodaysStockItemMobile";
